module.exports = __webpack_public_path__ + "img/pixel-logo-1.be054f96.svg";